import { render, staticRenderFns } from "./ItemTunings.vue?vue&type=template&id=cadcda72&scoped=true&"
import script from "./ItemTunings.vue?vue&type=script&lang=js&"
export * from "./ItemTunings.vue?vue&type=script&lang=js&"
import style0 from "./ItemTunings.vue?vue&type=style&index=0&id=cadcda72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadcda72",
  null
  
)

export default component.exports